import React from 'react'
import Home from '../views/Home/v2/HomeV2'
import { getLocalData } from '../services/StorageServices'
import ImportItemsPage from '../views/ImportItems/ImportItemsPage'
import PrintPage from '../views/PrintPage/PrintPage'
import ShipPage from '../views/ShipPage/ShipPage'
import CheckPage from '../views/CheckPage/components/CheckPage'
import PrintQRPage from '../views/QRCode/components/PrintQRPage'
import ListNextBoxesContainer from "../views/ListNextBoxes/components/ListNextBoxesContainer"
import ExportQRItems from './../views/ExportQRItems/ExportQRItems'
import SkuContainer from '../views/SkuPage/SkuContainer'
import OrdersReportContainer from '../views/OrdersReport/OrdersReportContainer'
import PriorityStorePageContainer from '../views/PriorityStore/components/PriorityStorePageContainer'
import ReGenerateLabelsContainer from '../views/ReGenerateLabels/components/ReGenerateLabelsContainer'
import BatchShipPageContainer from '../views/BatchShip/Components/BatchShipPageContainer'
import BrandsRulePageContainer from '../views/BrandsRule/components/BrandsRulePageContainer'
import SettingShippingRuleContainer from '../views/SettingShippingRule/components/SettingShippingRuleContainer'
import ListItemMarkErrorContainer from '../views/ListItemMarkError/components/ListItemMarkErrorContainer'
import StaticOverviewContainer from "../views/StaticsOverview/components/StaticOverviewContainer"
import UsersStaticsDetailContainer from '../views/UsersStaticsDetail/components/UsersStaticsDetailContainer'
import ProductionProcess from '../views/ProductionProcess/components/ProductionProcessContainer'
import IssuesManagementContainer from '../views/IssuesManagement/components/IssuesManagementContainer'
import CombineShipPageContainer from '../views/CombineShip/Components/CombineShipPageContainer'
import BoxLabelPage from '../views/BoxLabelPage/BoxLabelPage'
import {
    ActualHoursPage,
    WorkerAccountsPage,
    OutputByStagePage,
    OutputReportPage,
    StageListPage,
    WorkloadPage,
} from '../views/ProductionPlanning/components'

const iconHome = <i className="icon-home4"/>
const iconImport = <i className='icon-download4'/>
const iconPrintList = <i className='icon-printer'/>
const iconShipList = <i className='icon-truck'/>
const iconCheck = <i className='icon-vector'/>
const iconQRcode = <i className='icon-qrcode'/>
const iconBox2 = <i className='icon-dropbox icon-red'/>
const iconExportQRItems = <i className='icon-download'/>
const iconSku = <i className='icon-cog2'/>
const iconReport = <i className='icon-stats-dots'/>
const iconReGen = <i className='icon-price-tag3'/>
const iconPriorityStore = <i className="fa fa-level-up fa-lg" />
const iconShipment = <i className="icon-cabinet" />
const iconBrand = <i className="fa fa-bookmark" />
const iconRulers = <i className='fa fa-list-ul' />
const iconReports = <i className="fa fa-list-alt" />
const iconStaticDetail = <i className="fa fa-folder-open" />
const iconStaticOverview = <i className="fa fa-line-chart" />
const iconItemError = <i className="fa fa-tasks" />
const iconProductProcess = <i className="fa fa-wrench"/>
const iconIssue = <i className="fa fa-exclamation-triangle" />
const iconCombineShip = <i className="fa fa-cubes"></i>
const iconBoxLabel = <i className="fa fa-tag" />
const iconKpi = <i className="fa fa-tachometer" />
const iconKpiConfig = <i className="fa fa-sliders" />
const iconKpiWorkload = <i className="fa fa-users" />
const iconKpiOutput = <i className="fa fa-bar-chart" />
const iconKpiHours = <i className="fa fa-clock-o" />
/*
 * ⚠️ Bộ icon của repo là **FontAwesome 4.6.3** (`assets/css/icons/fontawesome/styles.min.css`),
 *    KHÔNG phải 4.7 hay 5/6. Những tên quen thuộc như `fa-id-card-o`, `fa-address-book-o`,
 *    `fa-user-circle-o` đều chỉ có từ 4.7 trở lên — khai chúng thì thẻ `<i>` render ra một ô
 *    TRỐNG, không lỗi, không cảnh báo, và menu mất icon mà không ai biết vì sao.
 *    Kiểm nhanh trước khi dùng một tên mới: `grep -c "\.<ten>:before" styles.min.css`.
 */
const iconKpiAccounts = <i className="fa fa-user-plus" />

const userRole = !!getLocalData('roles') && getLocalData('roles').length > 0 ? getLocalData('roles').map(i => i.name) : []


const viewsRoutes = [
    {
        path: '/',
        exact: true,
        name: 'Home',
        icon: iconHome,
        component: Home
    },
    {
        path: '/import-items',
        name: 'Import Items',
        icon: iconImport,
        component: ImportItemsPage,
        hidden: true,
    },
    {
        path: '/print',
        name: 'Print Item',
        icon: iconPrintList,
        component: PrintPage,
        hidden: true,
    },
    {
        path: '/ship',
        name: 'Ship Item',
        icon: iconShipList,
        component: ShipPage
    },
    {
        path: '/box-label',
        name: 'Dán Label Thùng',
        icon: iconBoxLabel,
        exact: true,
        component: BoxLabelPage,
    },
    {
        path: '/shipping-rule',
        name: 'Shipping-rule',
        icon: iconRulers,
        exact: true,
        component: SettingShippingRuleContainer,
        roles : userRole,
        hidden: true,
    },
    {
        path: '/check',
        name: 'Check',
        icon: iconCheck,
        component: CheckPage,
        hidden: true,
    },
    {
        path: '/qrcode',
        name: 'PrintQRPage',
        icon: iconQRcode,
        component: PrintQRPage,
    },
    {
        path: '/next-boxes',
        name: 'NextBox',
        icon: iconBox2,
        exact: true,
        component: ListNextBoxesContainer,
    },
    {
        path: '/batch-ship',
        name: 'Batch Ship Management',
        icon: iconShipment,
        exact: true,
        component: BatchShipPageContainer,
    },
    {
        path: '/export-qr-items',
        name: 'Xuất QR code',
        icon: iconExportQRItems,
        exact: true,
        component: ExportQRItems,
        hidden: true,
    },
    {
        path: '/re-generate-labels',
        name: 'Re Generate Labels',
        icon: iconReGen,
        exact: true,
        component: ReGenerateLabelsContainer
    },
    {
        path: '/orders-report',
        name: 'Orders Report',
        icon: iconReport,
        exact: true,
        component: OrdersReportContainer,
    },
    {
        path: '/priority-store',
        name: 'Danh sách ưu tiên',
        icon: iconPriorityStore,
        exact: true,
        component: PriorityStorePageContainer,
        roles: userRole.filter(role => ['fac_admin', 'fac_ffm'].includes(role)),
    },
    {
        path: '/sku-manager',
        name: 'Quản lý SKU',
        icon: iconSku,
        exact: true,
        component: SkuContainer,
    },
    {
        path: '/brands-rule',
        name: 'Brands Rule Management',
        icon: iconBrand,
        exact: true,
        component: BrandsRulePageContainer,
        roles: userRole.filter(role => ['fac_admin', 'fac_ffm'].includes(role)),
    },
    {
        path: '/production-process',
        name: 'Quản lý quy trình sản xuất',
        icon: iconProductProcess,
        exact: true,
        component: ProductionProcess,
    },
    {
        path: '/issues-management',
        name: 'Quản lý đơn lỗi',
        icon: iconIssue,
        exact: true,
        component: IssuesManagementContainer,
    },
    {
        path: '/combine-ship',
        name: 'Quản lý đơn gộp ship',
        icon: iconCombineShip,
        exact: true,
        component: CombineShipPageContainer
    },
    {
        path: '',
        name: 'Report',
        icon: iconReports,
        items : [
            {
                path: '/items-mark-error',
                name: 'Thống kê item lỗi QC',
                icon: iconItemError,
                exact: true,
                component: ListItemMarkErrorContainer
            },
            {
                path: '/static-overview',
                name: 'Statics Overview',
                icon: iconStaticOverview,
                exact: true,
                component: StaticOverviewContainer
            },
            {
                path: '/users-statics-detail',
                name: 'Báo cáo chi tiết',
                icon: iconStaticDetail,
                exact: true,
                component: UsersStaticsDetailContainer
            }
        ],
        roles : userRole.filter(role => role === "fac_admin")
    },
    {
        /*
         * Ba nhóm màn của service `production-planning-service`, đường dẫn đặt theo đúng namespace
         * của nó để URL trên trình duyệt và URL của API đọc ra cùng một thứ:
         *   /config/standard-time/*  định mức thời gian
         *   /planning/capacity       hoạch định năng lực
         *   /control/output*         kiểm soát sản lượng
         *
         * Bốn mục dưới đây là đường vào có menu. Bảy màn còn lại không có mục menu riêng:
         *   · cấu hình một công đoạn, SKU thiếu định mức, chi tiết sản lượng, cần kiểm tra
         *     ghi nhận, giải thích chỉ số — khai ở routes/view.js, vào bằng cách bấm từ màn khác;
         *   · tra cứu theo SKU và nhập/xuất Excel — KHÔNG còn là route, chúng là modal mở từ
         *     màn Chỉ số tiêu chuẩn (`StageListPage`), trạng thái đặt trên URL nên vẫn share
         *     link được.
         *
         * `roles` chỉ quyết định có HIỆN mục menu hay không. Ở đây lọc cả `fac_admin` lẫn
         * `fac_ffm` ⇒ nhóm menu này HIỆN với cả hai. Đó là chủ ý: quyền SỬA siết riêng ở
         * views/ProductionPlanning/helpers/permission.js (chỉ `fac_admin`), còn `fac_ffm` vào xem
         * ở chế độ chỉ đọc.
         *
         * (Khuôn `fac_admin`-only là nhóm Report ở trên, dòng `role === "fac_admin"` — đừng sửa
         * nhóm này theo khuôn đó, sẽ cắt mất quyền xem của toàn bộ tài khoản FFM.)
         */
        path: '',
        name: 'Định mức & sản lượng',
        icon: iconKpi,
        items : [
            {
                path: '/config/standard-time',
                name: 'Chỉ số tiêu chuẩn theo công đoạn',
                icon: iconKpiConfig,
                exact: true,
                component: StageListPage
            },
            {
                path: '/planning/capacity',
                name: 'Khối lượng & nhân lực theo công đoạn',
                icon: iconKpiWorkload,
                exact: true,
                component: WorkloadPage
            },
            {
                // `GET /control/output/report` (và records/suspects/dropped) đã đấu nối nguồn action
                // log thật (`itemhistories` qua connection catalog) — không còn 503 mặc định nữa, nên
                // bỏ `hidden`. Ba màn con (/control/output/detail · suspect · glossary) khai ở
                // routes/view.js, vốn không có mục menu nên không phải đụng tới.
                path: '/control/output',
                name: 'Sản lượng & giờ định mức theo nhân viên',
                icon: iconKpiOutput,
                exact: true,
                component: OutputReportPage
            },
            {
                // Cùng dữ liệu với màn trên, gộp theo CÔNG ĐOẠN thay vì theo tài khoản (SCR-M18-005).
                // `exact` bắt buộc: `/control/output` khai trước và nếu nó không exact thì đường này
                // không bao giờ tới lượt.
                path: '/control/output/by-stage',
                name: 'Sản lượng & giờ định mức theo công đoạn',
                icon: iconKpiOutput,
                exact: true,
                component: OutputByStagePage
            },
            {
                /*
                 * Màn NHẬP duy nhất của nhóm — mẫu số giờ công cho mọi chỉ số hiệu suất (FAC-26417).
                 *
                 * Để ở nhóm này dù là màn nhập chứ không phải báo cáo: người nhập giờ chính là người
                 * đọc hai màn sản lượng ngay trên, và số họ gõ ở đây hiện ngay thành hiệu suất ở đó.
                 * Tách sang nhóm khác là bắt họ nhớ hai chỗ cho một việc.
                 *
                 * `roles` của cả nhóm cho cả `fac_ffm` xem — đúng với `GET` của service. Quyền GHI
                 * siết riêng ở helpers/permission.js (`canEditActualHours`, chỉ `fac_admin`), vì
                 * `PUT` khai `@RequireRoles('fac_admin')`.
                 */
                path: '/control/output/actual-hours',
                name: 'Giờ làm thực tế',
                icon: iconKpiHours,
                exact: true,
                component: ActualHoursPage
            },
            {
                /*
                 * Bản đồ mã nhân viên ↔ tài khoản (FAC-26417).
                 *
                 * Ở ngay dưới màn Giờ làm thực tế vì nó là ĐIỀU KIỆN để nhập được chấm công: file
                 * chấm công chỉ có mã nhân viên, sản lượng chỉ có tài khoản. Người dùng gặp lỗi
                 * "mã chưa có tài khoản" ở màn trên sẽ sang đây, nên hai màn phải cạnh nhau.
                 */
                path: '/control/worker-accounts',
                name: 'Tài khoản nhân viên',
                icon: iconKpiAccounts,
                exact: true,
                component: WorkerAccountsPage
            }
        ],
        roles : userRole.filter(role => ['fac_admin', 'fac_ffm'].includes(role))
    }
]

export default viewsRoutes
